import { CurrencyUtils } from '../model/currency-utils'

/**
 * Exposes pure currency helpers to the component layer. Components and views
 * must not value-import `model/` directly (the MVVM internal-import rule);
 * this composable is the blessed indirection per the Vue MVVM contract.
 */
export function useCurrencyUtils() {
  return {
    /** True when `currency` is already present in `libraryCurrencies`. */
    isCurrencyAdded: CurrencyUtils.isCurrencyAdded,
    /** Eligible, non-historical, not-yet-added currencies, optionally search-filtered. */
    selectVisibleCurrencies: CurrencyUtils.selectVisibleCurrencies
  }
}
